module.exports = __webpack_public_path__ + "img/story-character-pc.209e8e3c.png";